/* Product page (main-product). Um arquivo, defer, sem dependencia.
   Junta o que antes eram tres pecas: bp-gallery.js (o elemento da galeria),
   picanha-pilot.js (quantidade, zoom, lightbox, barra fixa) e a logica de
   variante que vivia no bloco _product-buy (botoes visiveis, mapa JSON, troca
   de id, preco, preco por 100 g, disponibilidade e foto sem recarregar).
   Sem JavaScript o formulario continua postando para /cart/add com a variante
   inicial, que esta no input escondido. */
(() => {
  'use strict';

  /* ---- 1. A galeria: um botao por midia, um painel por midia. ---- */
  if (!customElements.get('bp-gallery')) {
    customElements.define('bp-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.addEventListener('click', event => {
          const button = event.target.closest('button[aria-controls]');
          if (button && this.contains(button)) this.select(button);
        });
        const initial = this.querySelector('[aria-pressed="true"]');
        if (initial) this.select(initial);
      }
      select(button) {
        const target = button.getAttribute('aria-controls');
        this.querySelectorAll('.bp-gallery__panel').forEach(panel => {
          const active = panel.id === target;
          panel.hidden = !active;
          const player = panel.querySelector('[data-player]');
          if (!player) return;
          if (!active) {
            player.querySelectorAll('video').forEach(video => video.pause());
            player.replaceChildren();
          } else if (!player.childElementCount) {
            const template = panel.querySelector('template');
            if (template) player.append(template.content.cloneNode(true));
          }
        });
        this.querySelectorAll('button[aria-controls]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }
    });
  }

  /* ---- 2. A pagina. ---- */
  function init() {
    document.querySelectorAll('[data-product-page]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';

      /* quantidade */
      const quantity = root.querySelector('#pp-quantity');
      const clamp = value => Math.min(99, Math.max(1, parseInt(value, 10) || 1));
      if (quantity) {
        root.querySelectorAll('[data-pp-step]').forEach(button => button.addEventListener('click', () => {
          quantity.value = clamp((parseInt(quantity.value, 10) || 1) + Number(button.dataset.ppStep));
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        }));
        quantity.addEventListener('change', () => { quantity.value = clamp(quantity.value); });
      }

      /* variante: botoes visiveis casam com o mapa JSON e trocam tudo sem recarregar */
      const mapElement = root.querySelector('#pp-variants');
      const idInput = root.querySelector('#pp-variant-id');
      const gallery = root.querySelector('bp-gallery');
      if (mapElement && idInput) {
        let variants = [];
        try { variants = JSON.parse(mapElement.textContent) || []; } catch (error) { variants = []; }
        const radios = Array.from(root.querySelectorAll('.pp-radio'));
        const price = root.querySelector('[data-pp-price]');
        const unit = root.querySelector('[data-pp-unit]');
        const button = root.querySelector('.pp-button');
        const stickyPrice = root.querySelector('[data-pp-sticky-price]');
        const stickyLabel = root.querySelector('[data-pp-sticky-label]');
        const currency = unit ? (unit.dataset.currency || '') : '';

        const steppers = Array.from(root.querySelectorAll('[data-pp-step]'));

        /* quantidade segue o botao: variante esgotada desliga os dois, como o Liquid faz na carga */
        const setButton = (available, label) => {
          steppers.forEach(step => { step.disabled = !available; });
          if (quantity) quantity.disabled = !available;
          if (!button) return;
          button.disabled = !available;
          button.textContent = label;
          if (available) {
            const arrow = document.createElement('span');
            arrow.setAttribute('aria-hidden', 'true');
            arrow.textContent = '→';
            button.append(' ', arrow);
          }
        };

        /* Combinacao sem variante (duas opcoes, um cruzamento que nao existe):
           primeiro tenta a primeira variante que carrega o valor que a pessoa
           acabou de escolher, como o Dawn faz, e reflete as outras opcoes nos
           radios. Sem nenhuma, o id e zerado para o formulario nao postar a
           variante anterior, e preco, botao e barra fixa mostram o estado. */
        const apply = changed => {
          const chosen = {};
          radios.forEach(radio => { if (radio.checked) chosen[radio.dataset.optionPosition] = radio.value; });
          const positions = Object.keys(chosen).map(Number).sort((a, b) => a - b);
          let match = variants.find(variant => positions.every(position => variant.options[position - 1] === chosen[position]));
          if (!match && changed) {
            const changedPosition = Number(changed.dataset.optionPosition);
            match = variants.find(variant => variant.options[changedPosition - 1] === changed.value);
            if (match) {
              radios.forEach(radio => { radio.checked = match.options[Number(radio.dataset.optionPosition) - 1] === radio.value; });
            }
          }
          if (!match) {
            const soldLabel = button ? button.dataset.soldLabel : '';
            idInput.value = '';
            if (price) price.textContent = soldLabel;
            if (unit) unit.textContent = currency;
            setButton(false, soldLabel);
            if (stickyPrice) stickyPrice.textContent = soldLabel;
            if (stickyLabel) stickyLabel.textContent = stickyLabel.dataset.view;
            return;
          }
          idInput.value = match.id;
          if (price) price.textContent = match.price;
          if (unit) unit.textContent = match.unit ? currency + ' · ' + match.unit : currency;
          setButton(match.available, button ? (match.available ? button.dataset.addLabel : button.dataset.soldLabel) : '');
          if (stickyPrice) stickyPrice.textContent = match.price + (match.weight ? ' · ' + match.weight + ' g' : '');
          if (stickyLabel) stickyLabel.textContent = match.available ? stickyLabel.dataset.buy : stickyLabel.dataset.view;
          if (gallery && match.media) {
            const thumb = gallery.querySelector('button[data-media-id="' + match.media + '"]');
            if (thumb) gallery.select(thumb);
          }
          try {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', match.id);
            window.history.replaceState(null, '', url.toString());
          } catch (error) { /* URL nao e o que importa aqui */ }
        };
        radios.forEach(radio => radio.addEventListener('change', () => apply(radio)));
      }

      /* zoom e lightbox */
      const dialog = root.querySelector('.pp-lightbox');
      const zoom = root.querySelector('[data-pp-zoom]');
      const stage = root.querySelector('.bp-gallery__stage');
      const image = () => stage ? stage.querySelector('.bp-gallery__panel:not([hidden]) > img') : null;
      let mediaObserver = null;
      if (dialog && zoom && stage) {
        zoom.addEventListener('click', () => {
          const source = image();
          if (!source || typeof dialog.showModal !== 'function') return;
          const target = dialog.querySelector('img');
          /* O maior candidato do srcset, nao o que o navegador escolheu para a
             vaga de 600 px: o dialog mede ate 900 px e a foto ampliada nao
             pode sair menos nitida do que a propria galeria. */
          const candidates = (source.srcset || '').split(',').map(item => item.trim().split(/\s+/)).filter(item => item[0]);
          const largest = candidates.sort((a, b) => (parseInt(b[1], 10) || 0) - (parseInt(a[1], 10) || 0))[0];
          target.src = largest ? largest[0] : (source.currentSrc || source.src);
          target.alt = source.alt;
          target.width = source.naturalWidth || 1400;
          target.height = source.naturalHeight || 1400;
          dialog.showModal();
        });
        const close = root.querySelector('[data-pp-close]');
        if (close) close.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
        mediaObserver = new MutationObserver(() => { zoom.hidden = !image(); });
        mediaObserver.observe(stage, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
        zoom.hidden = !image();
      }

      /* barra fixa: aparece quando a compra saiu da tela, some sobre o rodape */
      const sticky = root.querySelector('[data-pp-sticky]');
      const buy = root.querySelector('.pp-order');
      const footer = document.querySelector('.bbq-footer');
      const mobile = window.matchMedia('(max-width:760px)');
      let purchaseAbove = false, purchaseVisible = true, footerVisible = false;
      let observer = null;
      const update = () => { if (sticky) sticky.hidden = footerVisible || (mobile.matches ? purchaseVisible : !purchaseAbove); };
      if (sticky && buy) {
        observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target === buy) {
              purchaseVisible = entry.isIntersecting;
              purchaseAbove = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            }
            if (entry.target === footer) footerVisible = entry.isIntersecting;
          });
          update();
        });
        observer.observe(buy);
        if (footer) observer.observe(footer);
        mobile.addEventListener('change', update);
      }
      root.querySelectorAll('a[href="#pp-buy"]').forEach(link => link.addEventListener('click', () => {
        if (quantity) window.setTimeout(() => quantity.focus({ preventScroll: true }), 100);
      }));

      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(root)) {
          if (observer) observer.disconnect();
          if (mediaObserver) mediaObserver.disconnect();
          mobile.removeEventListener('change', update);
        }
      });
    });
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
